/** @jsxImportSource @emotion/react */

import React, { Fragment } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';

import { LoaderIcon } from '../../../components/Loader/bars';
import IfElse from '../../../components/IfElse';
import TradeTableRow from './Trade-row';

export default connect('tradeDoneList, fetchingTradeOrders')(
	({ tradeDoneList, coinUpper, inrDecimals, fetchingTradeOrders }) => (
		<table className="c-table c-table--fullWidth c-table--smallFont">
			<thead className="c-table__heading">
				<tr>
					<th
						className={`c-table__cell ${
							coinUpper === 'RAM' ? 'text-xs' : ''
						}`}
					>
						Time
					</th>
					<th className="c-table__cell text-right">
						{coinUpper === 'RAM' ? (
							<span
								className="text-xs"
								title="Price per 10 Bytes of RAM"
							>
								Price/10B RAM
							</span>
						) : (
							<Fragment>
								Price/
								{coinUpper}
							</Fragment>
						)}
					</th>
					<th className="c-table__cell text-right">Difference</th>
				</tr>
			</thead>
			<tbody id="tradeOrderBid">
				<IfElse
					condition={!fetchingTradeOrders}
					then={
						<IfElse
							condition={tradeDoneList.length > 0}
							then={tradeDoneList
								.slice(0, 6)
								.map((el, index, array) => {
									let difference;

									if (array.length !== index + 1) {
										difference =
											(el.rate - array[index + 1].rate) *
											100000;

										difference = difference
											? ((Math.ceil(
													Math.abs(difference)
											  ) /
													100000) *
													difference) /
											  Math.abs(difference)
											: 0;
									} else {
										difference = 0;
									}
									return (
										<TradeTableRow
											key={`${el.time}${el.btc}${el.rate}`}
											difference={difference}
											{...el}
											inrDecimals={inrDecimals}
										/>
									);
								})}
							else={
								<tr className="c-table__row text-lightGray">
									<td className="c-table__cell text-right">
										&mdash;
									</td>
									<td className="c-table__cell text-right">
										&mdash;
									</td>
									<td className="c-table__cell text-right">
										&mdash;
									</td>
								</tr>
							}
						/>
					}
					else={
						<tr className="c-table__row">
							<td colSpan="3">
								<div
									css={css`
										height: 250px;
									`}
									className="flex items-center justify-center flex-col"
								>
									<LoaderIcon
										fill="rgb(79, 70, 119, .6)"
										height="22"
									/>
									<div className="mt-4 text-lightGray">
										Fetching Orders
									</div>
								</div>
							</td>
						</tr>
					}
				/>
			</tbody>
		</table>
	)
);
